import { GLTF2Export } from "@babylonjs/serializers/glTF";
import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { newError, ERR_FAILED } from '@egr/wcf/modules/utils/error';
import { updateFrozenWorldMatrix } from '@egr/wcf/modules/core/utils/MeshUtils';
import { RoomElement } from '../mdl/RoomElement';
export class GltfScene {
    /**
     * Experimental GLTF export. Requires `/libs/babylonjs/babylonjs.serializers.min.js` to be loaded.
     */
    // tslint:disable-next-line:cyclomatic-complexity
    static async Export(pModel, pSceneElements = null, pRoomManager, pAdditionalNodes, pScaleFactor) {
        this.moriSafetyZones = [];
        //collect nodes to export
        const tExportNodes = new Set();
        const tElements = pSceneElements !== null && pSceneElements !== void 0 ? pSceneElements : pModel.elements;
        let tGLBTransform = new TransformNode('glbTransform', pModel.scene);
        tGLBTransform.rotation.y = Math.PI;
        tExportNodes.add(tGLBTransform);
        // scene elements
        for (let tElement of tElements) {
            tElement.node.parent = tGLBTransform;
            tElement.updateTransformation();
        }
        // additional nodes
        for (let tElement of pAdditionalNodes) {
            tElement.parent = tGLBTransform;
            updateFrozenWorldMatrix(tElement, true);
        }
        for (let tElement of tElements) {
            if (tElement instanceof RoomElement) {
                const tRE = tElement;
                if (tRE.type === "SafetyZone") {
                    this.moriSafetyZones.push(tRE);
                }
            }
            const tNodes = tElement.getNodes(true);
            for (let tNode of tNodes) {
                tExportNodes.add(tNode);
            }
        }
        // add additional nodes
        for (let tNode of pAdditionalNodes) {
            tExportNodes.add(tNode);
            let tcNodes = tNode.getChildTransformNodes(true);
            if (tcNodes.length > 0) {
                tExportNodes.add(tNode);
                for (let tchNode of tcNodes) {
                    tExportNodes.add(tchNode);
                }
            }
        }
        //run gltf export
        const tGltfOptions = {
            includeCoordinateSystemConversionNodes: true,
            // tslint:disable-next-line:cyclomatic-complexity
            shouldExportNode: (pNode) => {
                const tNN = pNode.name.toLocaleLowerCase().trim();
                if (pNode.isEnabled() === false || this.isInExcludeList(tNN)) {
                    return (false);
                }
                // check safetyzones
                if (tNN === 'shape2d_safetyzone') {
                    if (!pRoomManager.SafetyZonesVisible) {
                        return (false);
                    }
                    const telement = pNode.parent;
                    // tslint:disable-next-line:no-collapsible-if
                    if (telement != null) {
                        const telemName = telement.name.toLocaleLowerCase().trim();
                        if (telemName === "group_3d") {
                            const tSZvisible = this.checkSZVisibility(telement);
                            return (tSZvisible);
                        }
                    }
                    return (false);
                }
                if (tExportNodes.has(pNode)) {
                    if (this.isInExcludeList(tNN)) {
                        return (false);
                    }
                    const tlayerMesh = pModel.layers.getMeshLayer(pNode);
                    // check mesh layer
                    if (tlayerMesh != null) {
                        const tlayerName = tlayerMesh.toLocaleLowerCase().trim();
                        if (tlayerName.indexOf('_safetyzone') !== -1 ||
                            tlayerName.indexOf('_clearancezone') !== -1 ||
                            tlayerName.indexOf('_direction_block') !== -1 ||
                            tlayerName.indexOf('_free_space') !== -1 ||
                            tlayerName.indexOf('_bufferzone') !== -1 ||
                            tlayerName.indexOf('_trainingspace') !== -1 ||
                            tlayerName.indexOf('_trainingenvelope') !== -1) {
                            return (false);
                        }
                    }
                    return (true);
                }
                return (false);
            }
        };
        const tGltfData = await GLTF2Export.GLBAsync(pModel.scene, "scene", tGltfOptions);
        for (let tElement of tElements) {
            tElement.node.parent = null;
            tElement.updateTransformation();
        }
        // additional nodes
        for (let tElement of pAdditionalNodes) {
            tElement.parent = null;
            updateFrozenWorldMatrix(tElement, true);
        }
        tGLBTransform.dispose();
        //get glb
        const tSceneGlb = tGltfData.glTFFiles["scene.glb"];
        if (tSceneGlb == null)
            throw newError(ERR_FAILED, "scene.glb not found");
        return tSceneGlb;
    }
    static isInExcludeList(pNodeName) {
        let tfoundSubStr = false;
        GltfScene.excludeAlways.forEach((pListItem) => {
            if (pNodeName.indexOf(pListItem) !== -1) {
                tfoundSubStr = true;
            }
        });
        return (tfoundSubStr);
    }
    static checkSZVisibility(pgroup_3d) {
        let tRes = false;
        for (let tSZ of this.moriSafetyZones) {
            const tgrp3d = tSZ.group3d;
            if (tgrp3d === pgroup_3d) {
                return (tSZ.get_SafetyZone_Visibility());
            }
        }
        return (tRes);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
GltfScene.excludeAlways = ['skybox',
    'group_2d',
    'group_special',
    'group_additional',
    'wall_crossHair',
    'room:dummysafetyzone',
    'axistrihedron',
    'shadowplane',
    'gridline',
    'grid',
    'selectionbox',
    '_safetyzone_',
    '_direction_block',
    '_clearancezone',
    'shadow light'];
